import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from 'react-bootstrap/Table';

import DashboardAPI from "api/Dashboard";
import User from "api/User";

import ProductModel from 'models/Product';
import Collection from 'models/Collection';

import {
  LOGIN_SUCCESS,
	LOGOUT,
	SET_USER
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";

import DashboardForm from 'views/Dashboard';
import { useNavigate, useLocation } from 'react-router-dom';
import { messageActions } from 'redux/messageSlice';
import messageSlice from 'redux/messageSlice';
class Dashboard extends React.Component {
	
	constructor(props) {
		super(props);
		
		const { isLoggedIn, user } = props;
		this.state = {error: null,isLoaded: isLoggedIn,user: user};
	}
  
	async componentDidMount() {
		const { dispatch, isLoggedIn, user } = this.props;
		//if(isLoggedIn && user.id == 0) {
			this.getDashBoardData();
	//	} 
	}
	
	getDashBoardData = async() => {
		const { dispatch, user } = this.props;
		//if(isLoggedIn && user.id == 0) {
			try {
				dispatch(showLoader(true));
				var response = await DashboardAPI.getDashboard();
				dispatch({ type: SET_USER, payload: { user : response.data.data } });
				
//				user.addData( response.data );
				this.setState({user: user});
				dispatch(hideLoader());
			} catch(err) {
				console.log("err", err);
				dispatch(hideLoader());
				//dispatch({ type: LOGOUT });
			}
	}
	
	setCurrentCompany = (data) => {
		const {user, dispatch} = this.props;
		dispatch(showLoader());
		User.changeActiveCompany(data)
			.then((response) => {
				dispatch({ type: SET_USER, payload: { user : response.data } });
				dispatch(messageSlice.actions.submitMessage({action: SET_USER, payload: { user : response.data }}));

				dispatch(hideLoader());
			})
			.catch((err) => {
				console.log("ERROR LOG.. ", err);
				dispatch(hideLoader());
			})
	}
	
	render() {
		const { dispatch, isLoggedIn, user } = this.props;
		return <DashboardForm user={user} setCurrentCompanyEvent={this.setCurrentCompany} connectCompanyByCodeEvent={this.getDashBoardData}/>
	}
}



function mapStateToProps(state) {
  const { isLoggedIn, user } = state.auth;
  return {
    isLoggedIn,
	user
  };
}

export default connect(mapStateToProps)(Dashboard);